import CustomTag from 'components/CustomTag'
import React from 'react'

const DriveStatus = ({ status, offerStatus }) => {
  let colorType
  let tagMessage

  if (status == 'SCHEDULED') {
    colorType = 'grey'
    tagMessage = 'Scheduled'
  } else if (status == 'STARTED') {
    colorType = 'grey'
    tagMessage = 'Started'
  } else if (status == 'INVITED') {
    colorType = 'grey'
    tagMessage = 'Invited'
  } else if (status == 'SHORTLISTED') {
    colorType = 'green'
    tagMessage = 'Shortlisted'
  } else if (status == 'COMPLETED') {
    colorType = 'green'
    tagMessage = 'Completed'
  } else if (status == 'QUALIFIED') {
    colorType = 'green'
    tagMessage = 'Qualified'
  } else if (status == 'HOLD') {
    colorType = '#F3A66E'
    tagMessage = 'On hold'
  } else if (status == 'REJECTED') {
    colorType = 'red'
    tagMessage = 'Rejected'
  } else if (status == 'ABSENT') {
    colorType = 'red'
    tagMessage = 'Absent'
  } else if (status == 'RESCHEDULE_REQUESTED') {
    colorType = '#F3A66E'
    tagMessage = 'Req.Reschedule'
  } else if (status == 'SELECTED') {
    colorType =
      offerStatus === 'NOT_RELEASED' || offerStatus === 'ACCEPTED'
        ? 'green'
        : offerStatus === 'REJECTED'
        ? 'red'
        : 'grey'
    tagMessage =
      offerStatus === 'NOT_RELEASED'
        ? 'Selected'
        : offerStatus === 'RELEASED'
        ? 'Offer Released'
        : offerStatus === 'ACCEPTED'
        ? 'Offer Accepted'
        : offerStatus === 'NEGOTIATED'
        ? 'Offer Negotiated'
        : 'Offer Rejected'
  }

  return (
    <CustomTag colorType={colorType} message={tagMessage} bordered={false} />
  )
}

export default DriveStatus
